export const DIRECTION = {

	FORWARD: 'forward',
    BACKWARD: 'backward',
    STAY_ON_SAME: 'stayOnSame'
};

